import { NgModule } from '@angular/core';

import { MenuItems } from './menu-items/menu-items';
import {
  AccordionAnchorDirective,
  AccordionLinkDirective,
  AccordionDirective
} from './accordion';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxCurrencyModule } from 'ngx-currency';
import { DemoMaterialModule } from '../demo-material-module';
import { CustomPipeModule } from './pipe/pipe.module';
import { ElaunchViewDialog } from './dialog/elaunch-view-dialog/elaunch-view-dialog';



@NgModule({
  entryComponents: [

  ],
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ElaunchViewDialog,
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ElaunchViewDialog,
  ],
  imports: [
    DemoMaterialModule,
    CommonModule,
    FormsModule,
    CustomPipeModule,
    RouterModule,
    NgxCurrencyModule,
  ],
  providers: [MenuItems]
})
export class SharedModule {}
